var render = function () {
  var _vm$detailData;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('SectionTransformTable', [_c('PaymentForDistribution', {
    attrs: {
      "api-code": _vm.AP_UPD01,
      "dataPayment": _vm.detailPaymentData,
      "paymentId": (_vm$detailData = _vm.detailData) === null || _vm$detailData === void 0 ? void 0 : _vm$detailData.Id
    },
    on: {
      "accept-data": function (value) {
        var convertedValue = Object.assign({}, value, {
          ApPaymentId: value.ArPaymentId
        });
        delete convertedValue.ArPaymentId;
        var body = {
          ApPaymentDetail: convertedValue
        };
        _vm.acceptDataSaveForBill(body);
      },
      "accept-data-edit": function (value) {
        var convertedValue = Object.assign({}, value, {
          ApPaymentId: value.ArPaymentId
        });
        delete convertedValue.ArPaymentId;
        var body = {
          ApPaymentDetail: convertedValue
        };
        _vm.acceptDataEditForBill(body);
      }
    }
  }), _vm.detailData ? _c('ModalListPayAp', {
    attrs: {
      "isShow": _vm.isShowModalListPayAp,
      "data": _vm.detailData
    },
    on: {
      "refetch": function (data) {
        return _vm.fetchDetailApPayment({
          ApPayment: {
            Id: data.data.Id
          }
        });
      },
      "update:isShow": function ($event) {
        _vm.isShowModalListPayAp = $event;
      },
      "update:is-show": function ($event) {
        _vm.isShowModalListPayAp = $event;
      }
    }
  }) : _vm._e(), _c('SearchList', {
    attrs: {
      "title": 'ap_client_list_pay',
      "buttonText": "ar_common_search"
    },
    on: {
      "search": _vm.refetchData
    }
  }, [_c('FormItems', {
    attrs: {
      "formData": _vm.searchVal,
      "items": _vm.formItems
    },
    on: {
      "update:formData": function ($event) {
        _vm.searchVal = $event;
      },
      "update:form-data": function ($event) {
        _vm.searchVal = $event;
      }
    }
  })], 1), _c('b-card', [_c('EzTable', {
    ref: "tableRef",
    attrs: {
      "actions": _vm.actions,
      "selectionConfig": {
        hideSelectAll: true
      },
      "excelExport": _vm.arClient.api_ExcelAP_RP01,
      "excel-export-api-code": _vm.AP_RP03,
      "isLoading": _vm.isLoading,
      "columns": _vm.listPayApColumns,
      "dataSourceParams": _vm.searchVal,
      "dataSource": _vm.arClient.api_AP_RP01
    },
    on: {
      "action-1": function (data) {
        return _vm.fetchDetailApPayment({
          ApPayment: {
            Id: data.data.Id
          }
        });
      },
      "action-2": function (data) {
        return _vm.deletePayment({
          ApPayment: {
            Id: data.data.Id
          }
        });
      },
      "selection-changed": _vm.onSelectionChanged
    },
    scopedSlots: _vm._u([{
      key: "toolbar",
      fn: function () {
        return [_c('div', {
          staticClass: "d-flex"
        }, [_c('PermissionButton', {
          attrs: {
            "api-code": _vm.AP_UP02,
            "variant": "outline-primary"
          },
          on: {
            "click": _vm.handleApproveListPay
          }
        }, [_c('ez-icon', {
          attrs: {
            "icon": "ezAr-icon-navigation"
          }
        }), _vm._v(" " + _vm._s(_vm.$t("ap_client_approve")) + " ")], 1), _c('PermissionButton', {
          staticStyle: {
            "margin-left": "6px"
          },
          attrs: {
            "api-code": _vm.AP_UP04,
            "variant": "outline-primary"
          },
          on: {
            "click": _vm.handleConfirmListPay
          }
        }, [_c('ez-icon', {
          attrs: {
            "icon": "ezAr-icon-check"
          }
        }), _vm._v(" " + _vm._s(_vm.$t("golf_common_confirm")) + " ")], 1)], 1)];
      },
      proxy: true
    }])
  })], 1), _c('SidebarSection', {
    attrs: {
      "width": "900px",
      "title": "ap_client_detail",
      "isShow": _vm.isShowSidebar
    },
    on: {
      "update:isShow": function ($event) {
        _vm.isShowSidebar = $event;
      },
      "update:is-show": function ($event) {
        _vm.isShowSidebar = $event;
      }
    }
  }, [_c('div', {
    staticClass: "mt-1"
  }, [_c('b-row', {
    staticClass: "m-0 mb-1"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('h6', {
    staticClass: "content-title"
  }, [_vm._v(" " + _vm._s(_vm.$t("ar_voucher_general_information")) + " ")])]), _c('b-col', {
    staticClass: "d-flex justify-content-end",
    attrs: {
      "md": "6"
    }
  }, [_c('ez-icon', {
    staticClass: "cursor-pointer mx-50",
    class: {
      'd-none': !_vm.isValidPermission(_vm.AP_UP01)
    },
    attrs: {
      "icon": "ezAr-icon-edit",
      "size": "24",
      "color": "#114A9F"
    },
    on: {
      "click": function ($event) {
        _vm.isShowModalListPayAp = true;
      }
    }
  })], 1)], 1), _c('GeneralInfo', {
    attrs: {
      "leftWidth": "160px",
      "rightWidth": "80px",
      "list": _vm.listGeneral
    }
  })], 1), _c('div', {
    staticClass: "divider"
  }), _c('h6', {
    staticClass: "mb-2 mt-1 ml-1"
  }, [_vm._v(" " + _vm._s(_vm.$t("ar_client_selected_list_account")) + " ")]), _c('div', {
    staticClass: "px-1"
  }, [_c('EzTable', {
    attrs: {
      "toolbarConfig": {
        disableToolbar: true
      },
      "pageConfig": {
        disablePagination: true
      },
      "columns": _vm.listAccountColumns,
      "dataSource": _vm.detailData.ApPaymentDistribution
    }
  })], 1), _c('div', {
    staticClass: "divider"
  }), _c('div', {
    staticClass: "mb-2 mt-1 mx-1 d-flex justify-content-between"
  }, [_c('h6', [_vm._v(" " + _vm._s(_vm.$t("ar_client_list_payment")) + " ")]), _c('PermissionButton', {
    attrs: {
      "api-code": _vm.AP_RPD01,
      "disabled": _vm.isFutureDate(_vm.detailData.PaymentDate),
      "variant": "primary"
    },
    on: {
      "click": function () {
        return _vm.handleShowPayment();
      }
    }
  }, [_c('ez-icon', {
    attrs: {
      "icon": "ezAr-icon-plus-circle"
    }
  }), _c('span', {
    staticStyle: {
      "margin-left": "3px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("ar_client_add_pay")))])], 1)], 1), _c('div', {
    staticClass: "px-1 pb-3"
  }, [_c('EzTable', {
    attrs: {
      "toolbarConfig": {
        disableToolbar: true
      },
      "pageConfig": {
        disablePagination: true
      },
      "actions": _vm.paymentActions,
      "columns": _vm.listPaymentColumns,
      "dataSource": _vm.detailData.ListApPaymentDetail
    },
    on: {
      "action-1": function (data) {
        return _vm.handleShowPayment(data.data.Id);
      },
      "action-2": function (data) {
        return _vm.deleteApPayment({
          ApPaymentDetail: {
            Id: data.data.Id
          }
        });
      }
    }
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }